import React, { Component } from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import SubmissionPopUpLayout from '../SubmissionPopUpLayout';
import Stepper from '../Stepper';
import Submit from '../../containers/SubmitButton';
import './styles.css';
import ToggleShowSubmissionPopupMutation from '../../mutations/ToggleShowSubmissionPopup';
import GameQuery from '../../query/GameQuery';

class SubmissionPopUp extends Component {
	renderNumber(lastSubmission) {
		switch (lastSubmission) {
		case 1:
			return (
				<span>
						1<small>st</small>
				</span>
			);
		case 2:
			return (
				<span>
						2<small>nd</small>
				</span>
			);
		case 3:
			return (
				<span>
						3<small>rd</small>
				</span>
			);
		default:
			return (
				<span></span>
		)
		}
		
	}
	render() {
		const { history } = this.props;
		return (
			<GameQuery>
				{({ game }) => (
					<ToggleShowSubmissionPopupMutation>
						{toggleShowSubmissionPopup => (
							<div
								className="submission-pop-up"
								onClick={toggleShowSubmissionPopup}
							>
								<SubmissionPopUpLayout>
									<SubmissionPopUpLayout.Header>
										<FormattedHTMLMessage id="submit-confirm:1" />
										<span style={{ color: '#7ed321', fontWeight: 'bold' }}>
											{this.renderNumber(game.lastSubmission)}
										</span>{' '}
										<FormattedHTMLMessage id="submit-confirm:2" />
										<br />
										<FormattedHTMLMessage id="submit-confirm:3" />
									</SubmissionPopUpLayout.Header>
									<Stepper game={game} />
									{game.state !== 'COMPLETED' && <Submit history={history} />}
								</SubmissionPopUpLayout>
							</div>
						)}
					</ToggleShowSubmissionPopupMutation>
				)}
			</GameQuery>
		);
	}
}

export default SubmissionPopUp;
